/**
 * CookiePolicyPage - מדיניות עוגיות
 * Public route: /cookies — linked from the cookie consent banner, privacy policy, and footer.
 * Reflects the app's actual storage: essential session/auth + functional (accessibility
 * settings, consent choice). No analytics/marketing cookies at present.
 */

import { Link } from 'react-router-dom'

const PRIVACY_EMAIL = 'Iftach.Venger@gmail.com'
const VERSION = '1.0'
const LAST_UPDATED = '11 ביוני 2026'

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <article className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-10 leading-relaxed text-gray-800">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">מדיניות עוגיות (Cookies)</h1>
        <p className="text-sm text-gray-500 mb-6">גרסה {VERSION} · עודכן לאחרונה: {LAST_UPDATED}</p>

        <p className="mb-6">
          השירות עושה שימוש בעוגיות (Cookies) ובאחסון מקומי (Local Storage) לצורך תפעולו. מסמך זה מתאר
          אילו רכיבים בשימוש, מה הם עושים, וכיצד לנהל את העדפותיך.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. מהי עוגייה?</h2>
        <p>עוגייה היא קובץ טקסט קטן שהאתר מאחסן בדפדפן שלך, ומאפשר לזכור פעולות והעדפות לאורך זמן. בדומה לכך, אחסון מקומי שומר נתונים בדפדפן לצורך תפעול השירות.</p>

        <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. רכיבים הכרחיים (Strictly Necessary)</h2>
        <p className="mb-2">חיוניים לתפקוד הבסיסי של השירות. לא ניתן לבטל את ההסכמה להם.</p>
        <ul className="list-disc pr-6 space-y-1">
          <li><span dir="ltr">accessToken / session</span> — אימות וזיהוי המשתמש.</li>
          <li><span dir="ltr">cookieConsent</span> — זכירת בחירת העוגיות שלך (תוקף: שנה).</li>
        </ul>

        <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. רכיבים פונקציונליים</h2>
        <p className="mb-2">משפרים את החוויה אך אינם הכרחיים.</p>
        <ul className="list-disc pr-6 space-y-1">
          <li><span dir="ltr">binat-a11y-storage</span> — שמירת העדפות הנגישות שלך (גודל טקסט, ניגודיות וכד').</li>
        </ul>

        <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. עוגיות אנליטיקה ושיווק</h2>
        <p>נכון למועד עדכון מסמך זה, השירות אינו עושה שימוש בעוגיות אנליטיקה או שיווק של צד שלישי. אם ייווסף שימוש כזה בעתיד, נעדכן מסמך זה ונבקש את הסכמתך מראש.</p>

        <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. ניהול ההעדפות</h2>
        <p>
          באפשרותך לנהל את הסכמתך בכל עת דרך באנר העוגיות בכניסה לאתר, וכן דרך הגדרות הדפדפן שלך.
          חסימת רכיבים הכרחיים עלולה לפגוע בתפקוד השירות.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. יצירת קשר</h2>
        <p>
          לכל שאלה הנוגעת לעוגיות ניתן לפנות בדוא"ל{' '}
          <a className="text-primary-700 underline" href={`mailto:${PRIVACY_EMAIL}`} dir="ltr">{PRIVACY_EMAIL}</a>.
          ראה גם את <Link to="/privacy" className="text-primary-700 underline">מדיניות הפרטיות</Link> שלנו.
        </p>

        <div className="mt-10 pt-6 border-t border-gray-200">
          <Link to="/" className="text-primary-700 underline hover:text-primary-800">← חזרה לדף הבית</Link>
        </div>
      </article>
    </div>
  )
}
